const rutasCotizacion = {
  path: "cotizaciones",
  name: "cotizaciones",
  component: () =>
    import(
      /* webpackChunkName: 'Dashboard-Cotizaciones-Root' */ "@/modules/dashboard/pages/cotizaciones/"
    ),
  children: [
    {
      path: "rapida",
      name: "cotizacion-rapida",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Rapida' */ "@/modules/dashboard/pages/cotizaciones/rapida/"
        ),
      children: [
        {
          path: "",
          name: "cotizacion-rapida-empty",
          component: () =>
            import(
              /* webPackChunkName: 'Dashboard-Cotizacion-Rapida-Empty' */ "@/modules/dashboard/pages/cotizaciones/CotizacionVacia"
            ),
        },
        {
          path: ":token",
          name: "cotizacion-rapida-show",
          component: () =>
            import(
              /* webPackChunkName: 'Dashboard-Cotizacion-Rapida-Show' */ "@/modules/dashboard/pages/cotizaciones/ShowCotizacion"
            ),
        },
      ],
    },
    {
      path: ":token/show",
      name: "cotizacion-show",
      component: () =>
        import(
          /* webPackChunkName: 'Dashboard-Cotizacion-Show' */ "@/modules/dashboard/pages/cotizaciones/ShowCotizacion"
        ),
    },
    {
      path: "editable",
      name: "cotizacion-editable",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Editable' */ "@/modules/dashboard/pages/cotizaciones/CotizacionEditable"
        ),
    },
    {
      path: "estandar",
      name: "cotizacion-estandar",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Estandar' */ "@/modules/dashboard/pages/cotizaciones/estandar"
        ),
    },
    {
      path: "unidades",
      name: "cotizacion-unidades",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades' */ "@/modules/dashboard/pages/cotizaciones/unidades"
        ),
    },
    {
      path: "unidades/nueva",
      name: "cotizacion-unidades-nueva",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades-Nueva' */ "@/modules/dashboard/pages/cotizaciones/unidades/nueva"
        ),
    },
    {
      path: "unidades/historial",
      name: "cotizacion-unidades-historial",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades-Historial' */ "@/modules/dashboard/pages/cotizaciones/unidades/historial"
        ),
    },
    {
      path: "unidades/configuraciones",
      name: "cotizacion-unidades-parametros",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades-Perametros' */ "@/modules/dashboard/pages/cotizaciones/unidades/parametros/index"
        ),
    },
    {
      path: "unidades/:token/formato",
      name: "cotizacion-unidades-formato",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades-Formato' */ "@/modules/dashboard/pages/cotizaciones/unidades/formato"
        ),
    },
    {
      path: "unidades/:token/editar",
      name: "cotizacion-unidades-editar",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades-Editar' */ "@/modules/dashboard/pages/cotizaciones/unidades/editar"
        ),
    },
    {
      path: "unidades/configuraciones/:parametro_id/editar",
      name: "cotizacion-unidades-parametros-editar",
      component: () =>
        import(
          /* webpackChunkName: 'Dashboard-Cotizacion-Unidades-Perametros-Editar' */ "@/modules/dashboard/pages/cotizaciones/unidades/parametros/editar"
        ),
    },
  ],
};

export default rutasCotizacion;
